import { useLocale } from '../i18n/LocaleContext'

export function TopBar() {
  const { t } = useLocale()

  return (
    <div className="top-bar">
      <p className="top-bar-message">{t.topBarMessage}</p>
    </div>
  )
}
